// WPS SDK 统一配置文件
export const WPS_CONFIG = {
  // 基础配置
  appId: 'SX20250523SDKLUX',
  
  // 默认配置
  defaults: {
    fileId: 'demo-file',
    officeType: 'w', // Word文档
    mode: 'normal',
    
    // 显示选项 - 统一在这里配置
    isShowDocMap: false,        // 关闭大纲栏
    isShowTopArea: true,        // 显示顶部工具栏
    isShowHeader: true,         // 显示头部
    isShowToolbar: true,        // 显示工具栏
    isShowMenubar: true,        // 显示菜单栏
    isShowBottomStatusBar: true, // 显示状态栏
    isBestScale: true,          // 最佳缩放
    isParentFullscreen: false,
    isBrowserViewFullscreen: false
  }
};

// 获取WPS配置 - 简化版本
export function getWPSConfig(options = {}) {
  const config = {
    // 基础配置
    appId: options.appId || WPS_CONFIG.appId,
    endpoint: options.endpoint || WPS_CONFIG.endpoint,
    fileId: options.fileId || WPS_CONFIG.defaults.fileId,
    officeType: options.officeType || WPS_CONFIG.defaults.officeType,
    mode: options.mode || WPS_CONFIG.defaults.mode,
    
    // 挂载元素
    mount: options.mount,
    
    // 显示选项
    commonOptions: {
      isShowDocMap: typeof options.isShowDocMap !== 'undefined' ? options.isShowDocMap : WPS_CONFIG.defaults.isShowDocMap,
      isShowTopArea: typeof options.isShowTopArea !== 'undefined' ? options.isShowTopArea : WPS_CONFIG.defaults.isShowTopArea,
      isShowHeader: typeof options.isShowHeader !== 'undefined' ? options.isShowHeader : WPS_CONFIG.defaults.isShowHeader,
      isShowToolbar: typeof options.isShowToolbar !== 'undefined' ? options.isShowToolbar : WPS_CONFIG.defaults.isShowToolbar,
      isShowMenubar: typeof options.isShowMenubar !== 'undefined' ? options.isShowMenubar : WPS_CONFIG.defaults.isShowMenubar,
      isShowBottomStatusBar: typeof options.isShowBottomStatusBar !== 'undefined' ? options.isShowBottomStatusBar : WPS_CONFIG.defaults.isShowBottomStatusBar,
      isBestScale: typeof options.isBestScale !== 'undefined' ? options.isBestScale : WPS_CONFIG.defaults.isBestScale,
      isParentFullscreen: typeof options.isParentFullscreen !== 'undefined' ? options.isParentFullscreen : WPS_CONFIG.defaults.isParentFullscreen,
      isBrowserViewFullscreen: typeof options.isBrowserViewFullscreen !== 'undefined' ? options.isBrowserViewFullscreen : WPS_CONFIG.defaults.isBrowserViewFullscreen
    },
    wordOptions: {
      isShowDocMap: false
    }
  };

  // 合并其他自定义选项
  return { ...config, ...options };
}

// 预设配置
export const PRESETS = {
  // 标准模式 - 显示完整工具栏
  standard: {
    mode: 'normal',
    isShowDocMap: false,
    isShowTopArea: true,
    isShowToolbar: true,
    isShowMenubar: true,
    isShowBottomStatusBar: true
  },
  
  // 简洁模式 - 隐藏所有工具栏
  simple: {
    mode: 'simple',
    isShowDocMap: false,
    isShowTopArea: false,
    isShowToolbar: false,
    isShowMenubar: false,
    isShowBottomStatusBar: false
  },
  
  // 只读模式 - 显示工具栏但禁用编辑
  readonly: {
    mode: 'normal',
    isShowDocMap: false,
    isShowTopArea: true,
    isShowToolbar: true,
    isShowMenubar: true,
    isShowBottomStatusBar: true,
    readOnly: true
  }
};

// 使用预设配置
export function getPresetConfig(preset = 'standard', options = {}) {
  const presetConfig = PRESETS[preset] || PRESETS.standard;
  return getWPSConfig({ ...presetConfig, ...options });
}

export default WPS_CONFIG; 